/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

const savedDarkMode = localStorage.getItem('DARK_MODE');
const initialDarkMode =
  savedDarkMode !== null ? JSON.parse(savedDarkMode) : true;

const posSlice = createSlice({
  name: 'pos',
  initialState: {
    loading: false,
    productBanners: [],
    productGroups: [],
    products: [],
    preInvoices: [],
    selectedProductGroupId: 0,
    myOrders: [],
    favouriteProduct: [],
    allFavouriteProduct: [],
    darkMode: initialDarkMode,
    saveUserAddress: [],
    // userAddress: [],
  },
  reducers: {
    getProductBanners(state) {
      return { ...state };
    },
    setProductBanners(state, action) {
      state.productBanners = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    getProductGroups(state) {
      return { ...state };
    },
    setProductGroups(state, action) {
      state.productGroups = action.payload;
    },
    getProducts(state) {
      return { ...state };
    },
    setProducts(state, action) {
      state.products = action.payload;
    },
    setSelectedProductGroupId(state, action) {
      state.selectedProductGroupId = action.payload;
    },
    savePreInvoiceRequest: (state) => {
      return { ...state };
    },
    setPreInvoices: (state, actions) => {
      state.preInvoices = actions.payload;
    },
    getMyOrders: (state) => {
      return { ...state };
    },
    setMyOrders: (state, actions) => {
      state.myOrders = actions.payload;
    },
    toggleFavouriteRequest: (state, action) => {
      const { isDelete, productId, id } = action.payload;

      if (isDelete) {
        state.allFavouriteProduct = state.allFavouriteProduct.filter(
          (fav) =>
            String(fav.productId) !== String(productId) &&
            String(fav.favouriteProduct?.productId) !== String(productId)
        );
      } else {
        const newFav = {
          productId: productId,
          favouriteProduct: { productId: productId },
          id: id,
        };
        state.allFavouriteProduct.push(newFav);
      }
    },

    getAllFavouriteRequest: (state) => {
      state.loading = true;
    },

    setAllFavouriteProducts: (state, action) => {
      state.allFavouriteProduct = action.payload;
      state.loading = false;
    },

    setDarkMode: (state, action) => {
      state.darkMode = action.payload;
      localStorage.setItem('DARK_MODE', JSON.stringify(action.payload));
    },
    saveUserAddress: (state) => {
      state.loading = true;
    },
    setUserAddress: (state, action) => {
      state.loading = false;
      state.userAddressList = action.payload;
    },
    // getUserAddress: (state) => {
    //   state.loading = true;
    // },
    // setUserAddressValue: (state, action) => {
    //   state.loading = false;
    //   state.userAddress = action.payload;
    // },
  },
});

export const {
  setSelectedProductGroupId,
  setIsLoading,
  getProductBanners,
  setProductBanners,
  getProductGroups,
  setProductGroups,
  getProducts,
  setProducts,
  savePreInvoiceRequest,
  setPreInvoices,
  getMyOrders,
  setMyOrders,
  toggleFavouriteRequest,
  getAllFavouriteRequest,
  setAllFavouriteProducts,
  setDarkMode,
  setUserAddress,
  saveUserAddress,
  // getUserAddress,
  // setUserAddressValue,
} = posSlice.actions;

export default posSlice.reducer;

export const getAvailableProductBanners = createSelector(
  (state) => state.pos.productBanners,
  (productBanners) => productBanners
);

export const getAvailableProductGroups = createSelector(
  (state) => state.pos.productGroups,
  (productGroups) => productGroups
);

export const getAvailableProducts = createSelector(
  (state) => state.pos.products,
  (products) => products
);

export const getAvailableSelectedProductGroupId = createSelector(
  (state) => state.pos.selectedProductGroupId,
  (selectedProductGroupId) => selectedProductGroupId
);

export const getAvailablePreInvoices = createSelector(
  (state) => state.preInvoices.preInvoices,
  (preInvoices) => preInvoices
);

export const getAvailableMyorders = createSelector(
  (state) => state.pos.myOrders,
  (myOrders) => myOrders
);

export const getAvailableGetAllFavouriteProduct = createSelector(
  (state) => state.pos.allFavouriteProduct,
  (allFavouriteProduct) => allFavouriteProduct
);

export const getAvailableGetDarkMode = createSelector(
  (state) => state.pos.darkMode,
  (darkMode) => darkMode
);

// export const getAvailableUserAddress = createSelector(
//   (state) => state.pos.userAddress,
//   (userAddress) => userAddress
// );
